var App = App || {};

App.Login = (function ($) {
    'use strict';

    function Init() {
        var promoSections = $("#header-offcanvas-login .promo-section");

        $(document).ready(function () {
            if (promoSections.length) {
                var randomIndex = Math.floor(Math.random() * promoSections.length);
                promoSections.removeClass("active");
                promoSections.eq(randomIndex).addClass("active");
            }
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.Login.Init();
});